const getLocalStorageField = (field: string) => {
  return localStorage.getItem(field)
}

export default getLocalStorageField
